<div class="d-flex flex-column bg-dark text-white h-100">
  <div>
    <div class="d-flex align-items-center px-2 py-1 text-white-50">
      <h6 class="m-0 flex-grow-1">Console</h6>
      <button type="button"
              class="close"
              aria-label="Close"
              (click)="close()">
        <span aria-hidden="true"
              class="align-text-top">&times;</span>
      </button>
    </div>
  </div>
  <div #scrollContainer
       class="flex-grow-1 overflow-y-auto"
       [scrollTop]="scrollContainer.scrollHeight">
    <div #raw
         class="p-2"></div>
  </div>
</div>